module.exports = __webpack_public_path__ + "static/media/study 201026.d4dd4e83.png";